@if(!deviceDetectService.isMobile()) {
<div class="gallery-backdrop d-flex flex-column d-flex p-5">
  <div class="header d-flex align-items-center justify-betweens pb-3 w-100">
    <button (click)="close()">
      <i class="icon icon-times me-2"></i>
      {{ 'close' | translate }}
    </button>
    <div class="flex-grow-1 text-center">{{ currentIndex() + 1 }}/{{ images().length }}</div>
    <div class="text-right">
      @if(extraData?.shareFn) {
      <button class="icon-button" (click)="extraData?.shareFn()">
        <i class="icon icon-upload-file"></i>
      </button>
      } @if(extraData?.likeFn) {
      <button class="ms-2 icon-button" (click)="extraData?.likeFn()">
        @if(this.extraData.showSpinnerLike()) {
        <circular-spinner></circular-spinner>
        }@else {
        <i class="icon {{ !this.extraData.hasLike() ? 'icon-heart' : 'icon-favorite text-danger' }} "></i>
        }
      </button>
      }
    </div>
  </div>
  <div class="flex-fill d-flex justify-content-betweens align-items-center gallery-container w-100">
    <div class="pe-6">
      <button (click)="previousImage()" class="navigation">
        <i class="icon icon-angle-left"></i>
      </button>
    </div>
    <div class="flex-fill d-flex align-items-center justify-content-center h-100">
      @if(currentImage()) {
      <img [src]="currentImage()" (load)="isLoading.set(false)" [@fade] alt="image" />
      <div
        class="position-absolute right-0 left-0 top-0 bottom-0 d-flex align-items-center justify-content-center"
        *ngIf="isLoading()"
      >
        <circular-spinner [iconClass]="'icon-64 text-success'"></circular-spinner>
      </div>
      }
    </div>
    <div class="ps-6">
      <button (click)="nextImage()" class="navigation">
        <i class="icon icon-angle-right"></i>
      </button>
    </div>
  </div>
</div>
} @else {
<div class="gallery-backdrop d-flex flex-column d-flex p-4">
  <div class="header d-flex align-items-center justify-betweens pb-3 w-100">
    <button (click)="close()" class="mobile-back">
      <i class="icon icon-angle-left icon-24"></i>
    </button>
    <div class="flex-grow-1 text-right">{{ currentIndex() + 1 }}/{{ images().length }}</div>
  </div>
  <div class="flex-fill d-flex justify-content-center align-items-center gallery-container mobile w-100">
    <swiper #swiper class="swiper swiper-limit" [config]="swiperConfig">
      @for(image of images(); track image){
      <ng-template swiperSlide>
        <div class="w-100 d-flex justify-content-center align-items-center">
          <img [src]="image" class="mobile-image w-100" />
        </div>
      </ng-template>
      }
    </swiper>
  </div>
</div>
}
